import { BASE_PLAN_SUB_TYPES, planTypes } from '@/common/constants';

const C25_PLAN_CODES = [
  'monthly',
  'yearly',
  'edu20',
  'business_monthly',
  'business_yearly',
];

export const uiCategoryMap = {
  zm_wbd: "zwbbasic",
  zwb_plus: "zwbplus",
  zeud: 'eventsaas',
  zecsu: 'eventsaascore',
  zo_pro: 'pro',
  zeah: 'eventsaas-additionalhost',
  zeace: 'eventsaas-additionalcoeditor',
  zecah: 'eventsaascore-additionalhost',
  zecace: 'eventsaascore-additionalcoeditor',
  zecco: 'eventsaascore',
}

export const isC25Plan = (subscriptions = []) => {
  return subscriptions.findIndex(item => C25_PLAN_CODES.indexOf(item.plan_code) !== -1) !== -1;
}

export const getC25Plan = (subscriptions = []) => {
  return subscriptions.find(item => C25_PLAN_CODES.indexOf(item.plan_code) !== -1);
}

/**
 * Plans not supported by CIT flow:
 * - Zoom Phone
 * - Audio plan
 * - Zoom One Biz Plus
 *
 * @type {(string)[]}
 */
export const INR_OPC_CIT_UNSUPPORTED_PLAN_TYPES = [
  planTypes.ZOOM_PHONE,
  planTypes.TOLLFREE,
  BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS,
];
